<template>
  <pagefra>
    <div class="displayIndex container" v-loading.lock="loading">
      <panel>
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('播放模式')">
              <el-select v-model="form.mode">
                <el-option :label="$l('自动播放')" value="auto"></el-option>
                <el-option :label="$l('手动播放')" value="manual"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('自动播放时间间隔') + '(s)'">
              <el-select v-model="form.selectInterval">
                <el-option label="5" :value="5000"></el-option>
                <el-option label="10" :value="10000"></el-option>
                <el-option label="20" :value="20000"></el-option>
                <el-option label="30" :value="30000"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('自定义时间间隔') + '(s)'">
              <el-input-number
                v-model="form.customInterval"
                :min="0"
                :max="3600"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-button
              class="play"
              icon="el-icon-caret-right"
              type="primary"
              circle
              @click="play"
              v-show="!pageScroll.scroll"
            ></el-button>
            <el-button
              class="stop"
              type="primary"
              circle
              @click="stop"
              v-show="pageScroll.scroll && pageScroll.isHidePlay"
            >
              <svgicon name="stop"></svgicon>
            </el-button>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              round
              icon="el-icon-plus"
              @click="add()"
              v-if="!isSave"
              >{{ $l("新增") }}
            </el-button>
            <el-button
              type="primary"
              round
              icon="el-icon-circle-plus-outline"
              @click="save()"
              v-if="isSave"
              >{{ $l("保存") }}
            </el-button>
            <el-button
              type="info"
              round
              icon="el-icon-circle-plus-outline"
              @click="cancel()"
              v-if="isSave"
              >{{ $l("取消") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel type="gray" class="panel-img container-flex">
        <el-row type="flex" :gutter="basePadding">
          <draggable
            tag="div"
            v-model="pageList"
            @start="drag = true"
            @end="onDragEnd"
            :options="{
              group: 'description',
              disabled: false,
              animation: 200,
              ghostClass: 'ghost',
            }"
            draggable=".flip-list-item"
          >
            <transition-group
              type="transition"
              tag="div"
              class="list-group"
              :name="!drag ? 'flip-list' : null"
              :after-leave="delEnd"
            >
              <!-- <transition-group
            type="transition"
            tag="div"
            class="list-group"
            name="null"
            :after-leave="delEnd"
              >-->
              <el-col
                :span="6"
                v-for="(item, index) in pageList"
                :key="item.title"
                class="flip-list-item"
                :draggable="false"
              >
                <div class="imgItem">
                  <el-image
                    :src="
                      item.type == 'page'
                        ? item.src
                        : $apiConfig.root_host + item.thumbSrc
                    "
                    fit="fit"
                  >
                  </el-image>
                  <h4 :title="$l(item.title)">
                    <span>{{ index + 1 }}</span>
                    {{ $l(item.title) }}
                  </h4>
                  <el-button
                    type="primary"
                    circle
                    icon="el-icon-delete"
                    @click.prevent="del(item)"
                  ></el-button>
                </div>
              </el-col>
            </transition-group>
          </draggable>
        </el-row>
        <!-- <div class="add">
        <el-button type="primary" round icon="el-icon-circle-plus-outline"
          >新增</el-button
        >
        </div>-->
      </panel>

      <el-dialog :title="$l('新增展示页')" :visible.sync="addDialogFormVisible">
        <el-form
          ref="addForm"
          :model="addForm"
          :rules="rules"
          label-width="140px"
          size="medium"
          class="dialog-form"
        >
          <el-form-item :label="$l('类型')">
            <el-select v-model="addForm.type" @change="onTypeChange">
              <el-option :label="$l('页面')" value="page"></el-option>
              <el-option :label="$l('图片')" value="image"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('页面')" v-if="isShowFormItem">
            <el-select
              v-model="values"
              multiple
              collapse-tags
              :placeholder="$l('请选择')"
            >
              <el-option
                v-for="item in pages"
                :key="item.name"
                :label="$l(item.title)"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('标题')" prop="title" v-if="!isShowFormItem">
            <el-input v-model="addForm.title"></el-input>
          </el-form-item>
          <el-form-item :label="$l('图片')" v-if="!isShowFormItem">
            <el-upload
              ref="upload"
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :limit="2"
              :file-list="imageList"
              :on-change="onChange"
              :on-remove="onRemove"
              list-type="picture"
              :auto-upload="false"
            >
              <el-button size="small" round type="primary"
                >{{ $l("上传图片") }}
              </el-button>
              <div slot="tip" class="el-upload__tip">
                {{ $l("只能上传jpg/png文件") }}
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addDialogFormVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="submit()"
            >{{ $l("确 定") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src

import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";

import draggable from "vuedraggable";
import global from "@/mixins/global.js";
export default {
  name: "displayIndex",
  mixins: [global],
  inject: ["autoPageScroll", "stopPageScroll"],
  components: {
    panel,
    breadcrumb,
    draggable,
  },
  data() {
    var validateTitle = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入标题")));
      } else {
        callback();
      }
    };
    return {
      drag: true,
      form: {
        mode: "auto",
        interval: 30000,
        selectInterval: 30000,
        customInterval: 0,
      },
      addForm: {
        title: "",
        type: "page",
      },
      rules: {
        title: [
          { validator: validateTitle, trigger: "blur" },
          {
            max: 50,
            message: this.$l("长度不能超过50个字符"),
            trigger: "blur",
          },
        ],
      },
      pages: [],
      values: [],
      pageList: [
        // {
        //   title: "信息概览",
        //   type: "page",
        //   path: "/index",
        //   name: "index",
        //   src: require("@/assets/img/display_01.jpg")
        // },
        // {
        //   title: "定制页 1",
        //   type: "image",
        //   src: require("@/assets/img/display_08.jpg")
        // }
      ],
      oldPageList: [],
      delActive: "",
      addDialogFormVisible: false,
      imageFile: null,
      imageList: [],
      isShowFormItem: true,
      isSave: false,
      loading: false,
    };
  },
  methods: {
    play() {
      this.pageScroll.scrollList.forEach((item, index) => {
        sessionStorage.removeItem(item.name + "_data_list");
        sessionStorage.removeItem(item.name + "_data_total");
      });
      const username = this.$store.state.user.username;
      const selectInterval = this.form.selectInterval;
      const customInterval = this.form.customInterval;
      if (username) {
        localStorage.setItem(
          username + "_display_play",
          this.form.mode + "," + selectInterval + "," + customInterval
        );
      }
      this.form.interval =
        customInterval > 0 ? customInterval * 1000 : selectInterval;
      let page = this.pageScroll.scrollList.filter(
        (item) => item.index == this.$store.state.curPageIndex
      )[0];
      if (page && this.$route.name != page.name) {
        this.$router.push(page.path);
      }
      this.inFullScreen();
      this.$store.commit("startPageScroll", this.form);
      if (this.pageScroll.mode == "auto") {
        this.autoPageScroll();
      }
    },
    stop() {
      this.$store.commit("exitPageScroll");
      this.stopPageScroll();
    },
    del(item) {
      let list = this.pageList;
      for (let i = 0; i < list.length; i++) {
        if (list[i].index == item.index) {
          list.splice(i, 1);
          break;
        }
      }
      list.forEach((item, index) => {
        item.index = index + 1;
      });
      this.pageScroll.scrollList = list;
      this.isSave = true;
      this.drag = false;
    },
    delEnd() {
      this.drag = true;
    },
    onDragEnd(event) {
      let oldIndex = event.oldIndex;
      let newIndex = event.newIndex;
      if (oldIndex != newIndex) {
        this.isSave = true;
        this.pageList.forEach((item, index) => {
          item.index = index + 1;
        });
      }
    },
    save() {
      this.loading = true;
      let formData = new FormData();
      formData.append("json", JSON.stringify(this.pageList));
      formData.append("type", "page");
      let deleteImageList = [];
      this.oldPageList
        .filter((n) => n.type == "image")
        .forEach((item, index) => {
          if (this.pageList.filter((n) => n.src == item.src).length == 0) {
            deleteImageList.push(item);
          }
        });
      formData.append("deleteImageJson", JSON.stringify(deleteImageList));
      formData.append("operateType", 2);
      this.$http
        .post(this.$apiConfig.save_display_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            this.isSave = false;
            this.oldPageList = [];
            this.pageList.forEach((item, index) => {
              this.oldPageList.push(this.copyObject(item));
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    cancel() {
      this.isSave = false;
      this.pageList = [];
      this.oldPageList.forEach((item, index) => {
        this.pageList.push(this.copyObject(item));
      });
      this.pageScroll.scrollList = this.pageList;
    },
    onChange(file, fileList) {
      if (fileList.length > 0) {
        this.imageList = [fileList[fileList.length - 1]];
      }
      this.imageFile = file.raw;
    },
    onRemove() {
      this.imageFile = null;
    },
    onTypeChange(val) {
      this.isShowFormItem = val == "page";
      this.$refs.addForm.resetFields();
    },
    initPages() {
      this.loading = true;
      this.$http
        .get(this.$apiConfig.get_display_json_url)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            const data = result.data;
            if (data) {
              let arr = JSON.parse(data.json);
              arr.forEach((item, index) => {
                this.oldPageList.push(this.copyObject(item));
              });
              this.pageList = arr;
              this.pageScroll.scrollList = this.pageList;
            }
          } else {
            this.message(result.code, result.msg);
          }
          if (this.$route.query.token || this.$route.query.fromtoken) {
            this.play();
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    loadPages() {
      this.$http
        .get(this.$apiConfig.get_display_pages_url)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.pages = result.data;
            for (let i = 0; i < this.pages.length; i++) {
              if (
                this.pageList.filter((n) => n.name == this.pages[i].name)
                  .length > 0
              ) {
                this.pages.splice(i--, 1);
              }
            }
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    add() {
      this.addDialogFormVisible = true;
      if (this.imageFile) {
        this.$refs.upload.clearFiles();
        this.imageFile = null;
      }
      this.loadPages();
    },
    submit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let type = this.addForm.type;
          let tempPageList = [];
          this.pageList.forEach((item, index) => {
            tempPageList.push(this.copyObject(item));
          });
          let formData = new FormData();
          if (type == "page") {
            if (this.values.length < 1) {
              this.message(1, "请选择页面");
              return;
            }
            let datas = this.pages.filter(
              (item) => this.values.indexOf(item.name) >= 0
            );
            for (let i = 0; i < datas.length; i++) {
              let item = datas[i];
              item.type = type;
              if (
                item.type == "page" &&
                this.pageList.filter((n) => n.name == item.name).length > 0
              ) {
                this.message(1, "请勿重复添加相同页面");
                return;
              }
              item.index = tempPageList.length + 1;
              item.src = require("../../assets/img/" + item.name + ".jpg");
              tempPageList.push(item);
            }
          } else {
            if (!this.imageFile) {
              this.message(1, "请选择要上传的图片");
              return;
            }
            const isJPGOrPNG =
              this.imageFile.type === "image/jpeg" ||
              this.imageFile.type === "image/png";
            if (!isJPGOrPNG) {
              this.$message.error("上传图片只能是 jpg/png 格式!");
              return;
            }
            formData.append("file", this.imageFile);
            let obj = {
              index: this.pageList.length + 1,
              type: type,
              title: this.addForm.title,
              name: "imagePage",
              src: "",
              thumbSrc: "",
              path: "/display/imagePage",
            };
            tempPageList.push(obj);
          }
          formData.append("type", type);
          formData.append("json", JSON.stringify(tempPageList));
          formData.append("operateType", 1);
          this.loading = true;
          this.$http
            .post(this.$apiConfig.save_display_url, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              this.loading = false;
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                if (type == "image") {
                  let imageObj = tempPageList[tempPageList.length - 1];
                  imageObj.src = result.data.src;
                  imageObj.thumbSrc = result.data.thumbSrc;
                }
                this.pageList = [];
                this.pageScroll.scrollList = [];
                this.oldPageList = [];
                tempPageList.forEach((item, index) => {
                  this.pageList.push(item);
                  this.pageScroll.scrollList.push(item);
                  this.oldPageList.push(item);
                });
                this.values = [];
                this.addDialogFormVisible = false;
              }
            })
            .catch((error) => {
              this.loading = false;
              this.errorMessage(this.messageType.add);
              this.$sentry.captureException(error);
            });
        }
      });
    },
  },
  beforeCreate() {
    if (this.$route.query.token || sessionStorage.getItem("access_token")) {
      this.$store.state.siderConfig.isHide = true;
    }
  },
  mounted() {
    const username = this.$store.state.user.username;
    if (username) {
      const v = localStorage.getItem(username + "_display_play");
      if (v) {
        const arr = v.split(",");
        this.form.mode = arr[0];
        this.form.selectInterval = parseInt(arr[1]);
        this.form.customInterval = parseInt(arr[2]);
      }
    }
    this.initPages();
  },

  computed: {
    //这里需要把store 动态的数据放到computed里面才会同步更新 视图
    pageScroll() {
      return this.$store.state.pageScroll;
    },
  },
};
</script>
<style lang="scss" scoped>
.displayIndex {
}

.toolbar {
  /deep/ .toolbar-form .el-form-item__label {
    display: inline-block;
  }
  /deep/ .toolbar-form {
    .play {
      vertical-align: top;
      margin-left: 20px;
      padding: 7px;
      line-height: 0;
      i {
        font-size: 19px;
      }
    }
    .stop {
      vertical-align: top;
      margin-left: 20px;
      padding: 10px;
      line-height: 0;
      svg {
        width: 13px;
        height: 13px;
      }
    }
    .el-input-number {
      width: 100px;
      .el-input,
      .el-input__inner {
        width: 100px;
      }
    }
  }
}

.panel-img {
  .el-row {
    padding: 0 50px;
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }
  .list-group {
    position: relative;
    width: 100%;
    // display: flex;
    // flex-wrap: wrap;
  }
  .add {
    margin: 50px 0;
    // position: fixed;
    width: 100%;
    bottom: 10px;
    text-align: center;
    .el-button {
      // font-size: $--font-size-large;
      width: 10em;
    }
  }
}
.imgItem {
  cursor: move;
  position: relative;
  padding: 30px 0;
  .el-image {
    width: 100%;
    margin-bottom: 5px;
  }
  h4 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      display: inline-block;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid $--color-primary;
      color: $--color-primary;
      margin-right: 0.5em;
    }
  }
  .el-button {
    display: none;
    position: absolute;
    right: 10px;
    top: 40px;
    padding: 9px;
  }
  &:hover {
    .el-button {
      display: block;
    }
  }

  // &.add {
  //   border: 1px dashed $--border-color-base;
  //   height: 200px;
  // }
}
.flip-list-item {
  // transition: all 0.5s;
  display: inline-block;
}
.flip-list-move {
  //
  transition: transform 0.7s;
  transition-delay: 0.2s;
}
// .flip-list-active,
// .flip-list-active {
//   transition: all 0.5s;
// }
.flip-list-enter, .flip-list-leave-to
/* .list-complete-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.flip-list-leave-active {
  position: absolute;
  transition: all 0.5s;
}
// .no-move {
//   transition: transform 0s;
// }
.ghost {
  opacity: 0.5;
  // background: #c8ebfb;
}
.sortable-chosen {
  // .el-button {
  //   display: none !important;
  // }
}
.dialog-form {
  .el-input {
    width: 400px;
  }
  .el-select {
    width: 400px;
  }
  .el-cascader {
    width: 400px;
  }
}
</style>
